// extracted by mini-css-extract-plugin
var _1 = "_customerManagementCustomerTransactionTable-module__action-button-container";
var _2 = "_customerManagementCustomerTransactionTable-module__cancel-transaction-button";
var _3 = "_customerManagementCustomerTransactionTable-module__container";
var _4 = "_customerManagementCustomerTransactionTable-module__release-earmark-button";
var _5 = "_customerManagementCustomerTransactionTable-module__transaction-action-label";
export { _1 as "action-button-container", _2 as "cancel-transaction-button", _3 as "container", _4 as "release-earmark-button", _5 as "transaction-action-label" }
